import React from 'react';
import PropTypes from 'prop-types';
import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_KIND,
  TEXT_SIZE,
} from '@gc-npm/components.text';
import styles from './style';

const PillCapacity = ({ onClick, capacity, isSelected, name }) => {
  const handleChange = () => {
    onClick?.();
    import('@gc-npm/utils.metrics.send-ga-component-event')
      .then(({ default: sendGaComponentEvent }) => sendGaComponentEvent({
        componentContent: capacity,
        componentName: 'pill-capacity',
        eventType: 'click',
      }))
      .catch(() => {});
  };

  return (
    <>
      <li className="pill-capacity" role="none">
        <label className="pill-capacity--option">
          <input
            className="pill-capacity--input"
            type="radio"
            name={name}
            value={capacity}
            checked={isSelected}
            onChange={handleChange}
          />
          <span
            className={`pill-capacity--container ${
              isSelected ? 'pill-capacity--container--selected' : ''
            }`}
          >
            <TextInfo
              text={capacity}
              size={TEXT_SIZE.SUBTITLE1}
              color={isSelected ? TEXT_COLOR.BLUE_HIGH : TEXT_COLOR.GREY_700}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
              kind={TEXT_KIND.SPAN}
            />
          </span>
        </label>
      </li>
      <style jsx>{styles}</style>
    </>
  );
};

PillCapacity.propTypes = {
  name: PropTypes.string.isRequired,
  /**
   * Función que se ejecuta al seleccionar la capacidad
   */
  onClick: PropTypes.func,
  /**
   * Capacidad del dispositivo
   */
  capacity: PropTypes.string,
  /**
   * Estado seleccionado de la píldora
   */
  isSelected: PropTypes.bool,
};

PillCapacity.defaultProps = {
  onClick: null,
  capacity: null,
  isSelected: false,
};

export default PillCapacity;
